import React from "react";
import {
  briefcase,
  calender_icon_with_back,
  eyeWithBorder,
  location_with_blue_back,
  salary_with_background,
} from "../../../assets";
import { Avatar } from "@mui/material";
import { Clock, DownloadIcon } from "lucide-react";
function CandidateDetails({
  selectedMember,
  jobs,
  handlePreviewClick,
  handleDownloadClick,
  cvDownloadLoading,
  addCommasToNumber,
}) {
  console.log(selectedMember, "--selectedMember");
  return (
    <>
      {/* <h2>
        Candidate Details{" "}
        <span style={{ fontWeight: "normal", fontSize: "19px" }}>
          ({jobs?.job_title || "N/A"})
        </span>
      </h2> */}
      {selectedMember && (
        <div className="container">
          {/* Candidate Information Row */}
          <div className="row">
            <div className="candidate-user-info" gap={2} mb={2}>
              <div className="d-flex align-items-center">
                <Avatar
                  src={selectedMember?.name_profile?.image}
                  alt={selectedMember?.first_name}
                  sx={{ width: 80, height: 80 }}
                  className="me-2 mb-2"
                />
                <div>
                  <h3>
                    {selectedMember?.first_name} {selectedMember?.last_name}
                  </h3>
                  <p>{selectedMember?.email}</p>
                </div>
              </div>
              <div className="mt-2 mt-lg-0">
                {selectedMember?.cv && (
                  <div>
                    <button
                      className="small-button-cotain-view-all"
                      onClick={handleDownloadClick}
                      disabled={cvDownloadLoading}
                    >
                      {cvDownloadLoading ? (
                        "Downloading..."
                      ) : (
                        <>
                          <span>Download CV</span>{" "}
                          <DownloadIcon
                            className="ms-2"
                            height={16}
                            width={16}
                          />
                        </>
                      )}
                    </button>
                    <img
                      src={eyeWithBorder}
                      className="img-fluid ms-2 cursor-pointer"
                      alt="View CV"
                      // onClick={(e) => {
                      //   e.preventDefault();
                      //   e.stopPropagation();
                      //   handleViewCv();
                      // }}
                      onClick={() => {
                        handlePreviewClick(selectedMember);
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="cadndidate-content">
              {selectedMember?.job_description && (
                <div>
                  <h5>Cover Letter</h5>
                  <p>{selectedMember.job_description}</p>
                </div>
              )}
              <div className="border-bottom-1"></div>

              <div className="overview-div py-4">
                <h4 className="mb-0">Overview</h4>
                <div className="row">
                  <div className="col-lg-4">
                    <div className="candidate-card mt-2 mt-lg-3">
                      <span>Applied at</span>
                      <p>{selectedMember.date_of_birth}</p>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="candidate-card mt-2 mt-lg-3">
                      <span>Email</span>
                      <p>{selectedMember.email}</p>
                    </div>
                  </div>
                  {/* <div className="col-lg-4">
                              <div className="candidate-card mt-2 mt-lg-3">
                                <span>Location</span>
                                <p>{selectedMember.location}</p>
                              </div>
                            </div> */}
                </div>
              </div>
              <div className="border-bottom-1 mt-2 mt-lg-5"></div>
              <div className="candidate-job-detail py-4">
                <h4 className="mb-0">Job Detail:</h4>
                <div className="row">
                  <div className="col-lg-4 mt-3">
                    <div className="d-flex align-items-center">
                      <img src={calender_icon_with_back} alt="" />
                      <div className="ms-2">
                        <span>Job Title</span>
                        <p>{jobs?.job_title || "N/A"}</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 mt-3">
                    <div className="d-flex align-items-center">
                      <img src={briefcase} alt="" />
                      <div className="ms-2">
                        <span>Job Type:</span>
                        <p>{jobs?.job_type?.title || "N/A"}</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 mt-3">
                    <div className="d-flex align-items-center">
                      <img src={salary_with_background} alt="" />
                      <div className="ms-2">
                        <span>Salary:</span>
                        <p>
                          {jobs?.salary_type === "fixed"
                            ? jobs?.salary
                              ? `€${addCommasToNumber(jobs?.salary)} / ${
                                  jobs?.frequency_salary === "Monthly"
                                    ? "month"
                                    : jobs?.frequency_salary === "Yearly"
                                    ? "year"
                                    : jobs?.frequency_salary === "Anually"
                                    ? "annually"
                                    : jobs?.frequency_salary === "Weekly"
                                    ? "week"
                                    : jobs?.frequency_salary === "Daily"
                                    ? "day"
                                    : jobs?.frequency_salary === "Hourly"
                                    ? "hour"
                                    : ""
                                }`
                              : "N/A"
                            : jobs?.min_salary && jobs?.max_salary
                            ? `€${addCommasToNumber(
                                jobs?.min_salary
                              )} - €${addCommasToNumber(jobs?.max_salary)} / ${
                                jobs?.frequency_salary === "Monthly"
                                  ? "month"
                                  : jobs?.frequency_salary === "Yearly"
                                  ? "year"
                                  : jobs?.frequency_salary === "Anually"
                                  ? "annually"
                                  : jobs?.frequency_salary === "Weekly"
                                  ? "week"
                                  : jobs?.frequency_salary === "Daily"
                                  ? "day"
                                  : jobs?.frequency_salary === "Hourly"
                                  ? "hour"
                                  : ""
                              }`
                            : "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-8 mt-3">
                    <div className="d-flex align-items-center">
                      <img src={location_with_blue_back} alt="" />
                      <div className="ms-2">
                        <span>Location:</span>
                        <p>{jobs?.location || "N/A"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="candidate-description px-3s">
                <h4>Job Description</h4>
                <div
                  dangerouslySetInnerHTML={{
                    __html: jobs?.description || "N/A",
                  }}
                />
              </div>
            </div>
          </div>

          {/* Second Row - Additional Documents */}
          {/* {selectedMember?.additional_documents &&
                      selectedMember?.additional_documents?.length > 0 && (
                        <Grid
                          item
                          xs={12}
                          md={6}
                          sx={{ paddingTop: "4px !important" }}
                        >
                          <Typography variant="subtitle1">
                            <strong style={{ fontWeight: "bold" }}>
                              Additional Documents
                            </strong>
                          </Typography>
                          <Grid container spacing={1}>
                            {selectedMember?.additional_documents?.map(
                              (doc, index) => (
                                <Grid item key={index}>
                                  <Tooltip title={doc.split("/").pop()}>
                                    <IconButton
                                      onClick={() =>
                                        handleDownloadAdditiondOC(doc)
                                      }
                                      disabled={
                                        additionalDocDownloadLoading[doc]
                                      }
                                      sx={{ color: "navy" }}
                                    >
                                      {additionalDocDownloadLoading[doc] ? (
                                        <CircularProgress
                                          size={20}
                                          sx={{ color: "navy" }}
                                        />
                                      ) : (
                                        getFileIcon(doc, 35)
                                      )}
                                    </IconButton>
                                  </Tooltip>
                                </Grid>
                              )
                            )}
                          </Grid>
                        </Grid>
                      )} */}

          {/* Cover Letter - Full Width at the end */}
        </div>
      )}
      {/* <DialogActions>
                <button
                  className="small-button-contain-job-candidates"
                  onClick={handleCloseDetailPopup}
                  color="primary"
                >
                  Close
                </button>
              </DialogActions> */}
      {/* </Dialog> */}
    </>
  );
}

export default CandidateDetails;
